module.exports = __webpack_public_path__ + "media/eater-type/good-eater-093bd191.svg";